//@vendor
const React = require('react');
const PropTypes = require('prop-types');

//@components
const { LoadingSection } = require('commonsComponents/loadingSection');
const PreGrantedCreditWizard = require('../contractPreGrantedCredit/preGrantedCreditWizard/preGrantedCreditWizard');
class ContractPreGrantedCredit extends React.Component {

    render() {
        const { formalize,
            immAccounts,
            immFlagBasedFeatures,
            immPreGrantedCredit,
            immProfile,
            getBlockedAccounts,
            getContractInformation,
            getHiringDocuments,
            onAgreeCheckbox,
            onAgreeReset,
            onDownload,
            onPrint,
            preContractualMail,
            requestProfile,
            resetPrecontractualMail,
            sendLoansBarePrecontractualEmail,
            sendOverDraftSimpleEmail,
            sendPreContractualMail,
            setLoanAmount,
            setSelectedAccount,
            setVisibleStep,
            updateConfirmationCheckbox,
            validateStep,
            getINEDocument,
            getContractDraftDocument,
            getOverdraftInitOne,
            getOverdraftInitTwo,
            setInitApiFlag,
            officePrintReset,
            resetMailSent,
            checkRadioButtonOfficeStepThree,
            checkRadioButtonOfficeStepFour,
        } = this.props;
        const isFetching = immPreGrantedCredit.get('isFetching');
        let content;

        if (isFetching) {
            content = <LoadingSection />;
        } else {
            content = (
                <PreGrantedCreditWizard
                    formalize={formalize}
                    immAccounts={immAccounts}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    immPreGrantedCredit={immPreGrantedCredit}
                    immProfile={immProfile}
                    getBlockedAccounts={getBlockedAccounts}
                    getContractInformation={getContractInformation}
                    getHiringDocuments={getHiringDocuments}
                    onAgreeCheckbox={onAgreeCheckbox}
                    onAgreeReset={onAgreeReset}
                    onDownload={onDownload}
                    onPrint={onPrint}
                    preContractualMail={preContractualMail}
                    requestProfile={requestProfile}
                    resetPrecontractualMail={resetPrecontractualMail}
                    sendLoansBarePrecontractualEmail={sendLoansBarePrecontractualEmail}
                    sendOverDraftSimpleEmail={sendOverDraftSimpleEmail}
                    sendPreContractualMail={sendPreContractualMail}
                    setLoanAmount={setLoanAmount}
                    setSelectedAccount={setSelectedAccount}
                    setVisibleStep={setVisibleStep}
                    updateConfirmationCheckbox={updateConfirmationCheckbox}
                    validateStep={validateStep}
                    getINEDocument={getINEDocument}
                    getContractDraftDocument={getContractDraftDocument}
                    getOverdraftInitOne={getOverdraftInitOne}
                    getOverdraftInitTwo={getOverdraftInitTwo}
                    setInitApiFlag={setInitApiFlag}
                    officePrintReset={officePrintReset}
                    resetMailSent={resetMailSent}
                    checkRadioButtonOfficeStepThree={checkRadioButtonOfficeStepThree}
                    checkRadioButtonOfficeStepFour={checkRadioButtonOfficeStepFour}
                />
            );
        }

        return content;
    }
}

ContractPreGrantedCredit.propTypes = {
    formalize: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immPreGrantedCredit: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    getContractInformation: PropTypes.func.isRequired,
    getHiringDocuments: PropTypes.func.isRequired,
    onAgreeCheckbox: PropTypes.func.isRequired,
    onAgreeReset: PropTypes.func.isRequired,
    onDownload: PropTypes.func.isRequired,
    onPrint: PropTypes.func.isRequired,
    preContractualMail: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    sendLoansBarePrecontractualEmail: PropTypes.func.isRequired,
    sendOverDraftSimpleEmail: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    setLoanAmount: PropTypes.func.isRequired,
    setSelectedAccount: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    updateConfirmationCheckbox: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    getINEDocument: PropTypes.func.isRequired,
    getContractDraftDocument: PropTypes.func.isRequired,
    getOverdraftInitOne: PropTypes.func.isRequired,
    setInitApiFlag: PropTypes.func.isRequired,
    officePrintReset: PropTypes.func.isRequired,
    resetMailSent: PropTypes.func,
    checkRadioButtonOfficeStepThree: PropTypes.func,
    checkRadioButtonOfficeStepFour: PropTypes.func,
};

module.exports = ContractPreGrantedCredit;
